import { config } from '@config';
import { concatMap, tap, map } from 'rxjs/operators';
import { RxUtils, TypeUtils } from '@utils';
import { httpService, logger } from '@services';
import { CarListBandModel } from './car-list-band-model.class';

export class CarListBandModelService {
	private getUrl() {
		return `${config.apiUrl}/car-list-band-model`;
	}

	getAll(carListBandId: string) {
		return httpService.get<CarListBandModel[]>(this.getUrl(), `all/${carListBandId}`).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.getAll.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((results) => TypeUtils.convert(CarListBandModel, results))
		);
	}

	create(body: Pick<CarListBandModel, 'carListBandId' | 'carModelId'>) {
		return httpService.post<CarListBandModel>(this.getUrl(), '', { body, errorHandler: 'notification' }).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.create.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty'))),
			map((result) => TypeUtils.convert(CarListBandModel, result))
		);
	}

	delete(id: string) {
		return httpService.delete<unknown>(this.getUrl(), id, { errorHandler: 'notification' }).pipe(
			tap((result) => logger.debug(`[${this.constructor.name}.${this.delete.name}]`, result)),
			concatMap((result) => RxUtils.valueOrThrow(result, new Error('Response is empty')))
		);
	}
}

export const carListBandModelService = new CarListBandModelService();
